import React, { useEffect } from 'react';
import { useWindowWidth } from '@lux/hooks';
import { screenSizes } from '@lux/tokens';

import {
    SmartBanner as AppSmartBanner,
    AppStoreUrlByCountryKeys,
    BaseSmartBannerProps,
} from '@pegasus/smartbanner';
import { getDeviceOperatingSystem, isSafariBrowserOfiOS } from '@pegasus/utils';
import { useTranslationContext } from '@pegasus/translation';

import { getCookie } from '@client/helpers/cookie';
import { useConfig } from '@browsing/config';

export interface SmartBannerProps {
    updateComponentRemovalState: () => void;
    listenToBannerPosition: BaseSmartBannerProps['listenToBannerPosition'];
}

const SmartBanner = ({ updateComponentRemovalState, listenToBannerPosition }: SmartBannerProps) => {
    const { countryCode, isEnabled } = useConfig();
    const localeCountry = countryCode.toLocaleUpperCase();

    let isSmartBannerFeatureEnabled = isEnabled('smartbanner');

    const { translations } = useTranslationContext();

    const screenWidth = useWindowWidth();
    const isMobileView = screenWidth <= screenSizes.md;

    // For live test
    if (getCookie('smartbanner_test')) {
        isSmartBannerFeatureEnabled = true;
    }

    useEffect(() => {
        if (!isMobileView || !isSmartBannerFeatureEnabled) {
            updateComponentRemovalState();
        }
    }, [updateComponentRemovalState, isMobileView, isSmartBannerFeatureEnabled]);

    if (!isMobileView || !isSmartBannerFeatureEnabled) {
        return null;
    }

    return (
        <AppSmartBanner
            hideInSafariBrowserOfiOS={isSafariBrowserOfiOS()}
            listenToBannerPosition={listenToBannerPosition}
            appPlatform={getDeviceOperatingSystem()}
            localeCountry={localeCountry as AppStoreUrlByCountryKeys}
            translations={translations}
            onClose={updateComponentRemovalState}
            bannerContext="mylounge"
        />
    );
};

export default SmartBanner;
